export function adjustHeight() {
    var cardTitles = document.querySelectorAll('.video-card-title');
    var maxHeight = 0;

    // Iterate over each card title to find the greatest height
    cardTitles.forEach(function(title) {
        var titleHeight = title.offsetHeight;
        if (titleHeight > maxHeight) {
            maxHeight = titleHeight;
        }
    });

    // Set all card titles to the greatest height
    cardTitles.forEach(function(title) {
        title.style.height = maxHeight + "px";
    });

}